export default "dist/images/block-team-member-half.124d11f.png";